module.exports = __webpack_public_path__ + "img/empty.79f878ed.svg";